
import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageHeader from '@/components/PageHeader';
import LogoScroller from '@/components/LogoScroller';

const Terms = () => {
  return (
    <div className="min-h-screen bg-ai-dark">
      <Helmet>
        <title>Terms of Service - AI World Congress 2026 - November 25-26, London UK - AI Conference</title>
        <meta name="description" content="Terms of Service for AI World Congress 2026. Event registration, cancellation policy, and code of conduct information." />
        <link rel="canonical" href="https://aiconference.london/terms" />
        <meta property="og:title" content="Terms of Service - AI World Congress 2026 - November 25-26, London UK - AI Conference" />
        <meta property="og:description" content="Terms of Service for AI World Congress 2026 event registration and attendance." />
        <meta property="og:url" content="https://aiconference.london/terms" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Terms of Service - AI World Congress 2026 - November 25-26, London UK - AI Conference" />
      </Helmet>
      <Header />
      <PageHeader 
        title=""
        subtitle=""
        backgroundImage="/lovable-uploads/530fddbf-4fea-4198-860f-8165d2f8b445.png"
      />
      <div className="relative z-10 -mt-16">
        <div className="relative py-16 md:py-24 overflow-hidden bg-gradient-to-b from-purple-900/80 to-black">
          <div className="absolute inset-0 w-full h-full overflow-hidden z-0">
            <div className="absolute w-full h-[40%] bottom-0 bg-gradient-to-t from-black to-transparent"></div>
            <div className="absolute w-full h-[500px] bottom-0 left-0 right-0">
              <svg className="absolute bottom-0 w-full" viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg">
                <path 
                  fill="#000000" 
                  fillOpacity="1" 
                  d="M0,128L48,138.7C96,149,192,171,288,176C384,181,480,171,576,144C672,117,768,75,864,80C960,85,1056,139,1152,160C1248,181,1344,171,1392,165.3L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
                  className="animate-pulse"
                  style={{ animationDuration: '15s' }}
                ></path>
              </svg>
            </div>
          </div>
          
          <div className="container mx-auto px-4 relative z-10">
            <div className="text-center max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-5xl font-bold mb-8">
                <span className="text-white">Terms of </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">Service</span>
              </h1>
            </div>
          </div>
        </div>
      
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto prose prose-invert">
            <h3 className="text-xl font-semibold text-white mt-8 mb-4">1. Acceptance of Terms</h3>
            <p className="text-gray-300 mb-4">
              By accessing and using the AI Conference London - AI World Congress 2026 website and services, 
              you agree to be bound by these Terms of Service.
            </p>

            <h3 className="text-xl font-semibold text-white mt-8 mb-4">2. Event Registration</h3>
            <p className="text-gray-300 mb-4">
              All conference registrations must be completed through our official website. 
              Registrations are non-transferable unless otherwise stated.
            </p>

            <h3 className="text-xl font-semibold text-white mt-8 mb-4">3. Cancellation Policy</h3>
            <p className="text-gray-300 mb-4">
              Full 100% refund within 14 days of booking. After that, tickets are non-refundable but can be
              transferred to another attendee or next event. Please contact us for assistance.
            </p>

            <h3 className="text-xl font-semibold text-white mt-8 mb-4">4. Code of Conduct</h3>
            <p className="text-gray-300 mb-4">
              All attendees must adhere to our Code of Conduct. We reserve the right to refuse entry or remove 
              any person from the event who does not comply.
            </p>

            <h3 className="text-xl font-semibold text-white mt-8 mb-4">5. Intellectual Property</h3>
            <p className="text-gray-300 mb-4">
              All content presented at the conference remains the intellectual property of the respective speakers 
              and organizations. Unauthorized recording or reproduction is prohibited.
            </p>
          </div>
        </div>
      </div>
      <LogoScroller />
      <Footer />
    </div>
  );
};

export default Terms;
